var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-5",staticStyle:{"width":"250px","height":"250px"}},[_c('Doughnut',{attrs:{"id":"my-chart-id","options":_vm.chartOptions,"data":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }